<template>
    <keep-alive>
        <form @submit.prevent novalidate>

            <template v-if="form.value && form.value.settings && form.value.settings['form_progress']">
                <div class="progress">
                    <div class="count">{{ form.value.local['step'] }} {{ formProgress.currentStep }}
                        {{ form.value.local['from'] }} {{ formProgress.stepsCount }}
                    </div>
                    <div class="percent">{{ formProgress.percent }}%</div>
                </div>
                <div class="progressLine">
                    <div class="placeholder">
                        <div class="line" :style="{width: formProgress.percent + '%'}"></div>
                    </div>
                </div>
            </template>

            <template
                    v-if="currentStep.value && currentStep.value['step_type'] && currentStep.value['step_type'] === 'sms-confirm'">
                <h3 class="stepTitle">{{ form.value.local['sms_confirm_title'] }}</h3>
                <div v-if="timerText && timerText.value">
                    <p class="info">{{ form.value.local['sms_confirm_text'] }} {{ formData.value.phone }}</p>
                    <div class="timer">
                        {{ form.value.local['sms_confirm_repeat'] }} {{ timerText.value }}
                    </div>
                </div>
            </template>

            <template
                    v-else-if="currentStep.value && currentStep.value['step_type'] && currentStep.value['step_type'] === 'email-confirm'">
                <h3 class="stepTitle">{{ form.value.local['email_confirm_title'] }}</h3>
                <div class="info" v-if="form.value.local['email_confirm_text']"
                     v-html="form.value.local['email_confirm_text']"></div>
                <div v-if="userEmail.title && userEmail.text" class="message">
                    <h4 class="messageTitle">{{ userEmail.title }}</h4>
                    <p>{{ userEmail.text }}</p>
                </div>
                <div v-if="timerText && timerText.value">
                    <div class="timer">
                        {{ form.value.local['email_confirm_repeat'] }} {{ timerText.value }}
                    </div>
                </div>
            </template>

            <template v-else>
                <h3 v-if="currentStep.value && currentStep.value['step_head']" class="stepTitle">
                    {{ currentStep.value['step_head'] }}</h3>
                <p v-if="currentStep.value && currentStep.value['step_description']" class="stepText"
                   v-html="stepText(currentStep.value['step_description'])"></p>
            </template>

            <div v-if="currentStep.value && currentStep.value['fields']"
                 v-for="(field, name, index) in currentStep.value['fields']" :key="index">

                <template v-if="field.type === 'grid-checkbox'">
                    <div class="gridCheckbox">
                        <label v-for="(gridItem, gridItemKey, gridItemIndex) in field.offers_list" :key="gridItemKey">
                            <input
                                    type="checkbox"
                                    v-model="currentStep.value['fields'][name]['value']"
                                    :id="'field_' + gridItemKey"
                                    :value="gridItemKey"
                                    :class="{ 'error': currentStep.value && currentStep.value['validation'] && currentStep.value['validation'][name] }"
                            />
                            <span v-html="gridItem"></span>
                        </label>
                    </div>
                </template>

                <template v-else-if="field.type === 'checkbox'">
                    <div class="checkboxHolder">
                        <input
                                v-model="currentStep.value['fields'][name]['value']"
                                :id="'field_' + name"
                                type="checkbox"
                                :value="false"
                                :class="{ 'error': currentStep.value && currentStep.value['validation'] && currentStep.value['validation'][name] }"
                                @change="handleInput(name)"
                        />
                        <div class="label">
                            <label :for="'field_' + name"><span class="checkbox"></span><span></span></label>
                            <div v-html="(field.text ?? field.name_field)"></div>
                        </div>

                        <span v-if="currentStep.value && currentStep.value['validation'] && currentStep.value['validation'][name]" class="error">
                            {{ currentStep.value['validation'][name] }}
                        </span>
                    </div>
                </template>
                <template v-else-if="field.type === 'select'">
                    <div class="selectHolder">
                        <label :for="'field_' + name" v-html="field.name_field"></label>
                        <vue-select
                            :id="'field_' + name"
                            v-model="currentStep.value['fields'][name]['value']"
                            :options="prepareSelectOptions(field.list ?? field.values)"
                            :reduce="label => label.value"
                            :placeholder="field.placeholder ?? field.name_field"
                            :class="{ 'error': currentStep.value && currentStep.value['validation'] && currentStep.value['validation'][name] }"
                            @click="handleInput(name, $event.target.value)"
                        >
                            <template #no-options="{ search, searching, loading }">
                                {{ form.value.local['no_options'] }}
                            </template>
                        </vue-select>
                        <span v-if="currentStep.value && currentStep.value['validation'] && currentStep.value['validation'][name]" class="error">
                            {{ currentStep.value['validation'][name] }}
                        </span>
                    </div>
                </template>

                <template v-else-if="field.type === 'radio'">
                    <div class="radioHolder">
                        <div class="label" v-html="field.name_field"></div>
                        <div class="grid">
                            <label
                                    v-for="(gridItem, gridItemKey, gridItemIndex) in field.list ?? field.values"
                                    :key="gridItemKey"
                                    :class="{ 'error': currentStep.value && currentStep.value['validation'] && currentStep.value['validation'][name] }"
                            >
                                <input
                                        type="radio"
                                        v-model="currentStep.value['fields'][name]['value']"
                                        :value="gridItemKey"
                                        @change="handleInput(name)"
                                />
                                <div v-html="gridItem"></div>
                            </label>
                        </div>
                        <span v-if="currentStep.value && currentStep.value['validation'] && currentStep.value['validation'][name]" class="error">
                            {{ currentStep.value['validation'][name] }}
                        </span>
                    </div>
                </template>

                <template v-else>
                    <div class="inputHolder">
                        <label :for="'field_' + name" v-html="field.name_field"></label>
                        <input
                                v-maska="currentStep.value['fields'][name]"
                                v-model="currentStep.value['fields'][name]['value']"

                                :data-maska="formatMask(field)"
                                :data-maska-tokens="maskToken(field)"
                                :inputmode="field.inputmode ? field.inputmode : 'text'"

                                :id="'field_' + name"
                                :name="name"
                                :placeholder="field.placeholder ?? field.name_field"
                                @input="handleInput(name, $event.target.value)"
                                :class="{
                                    'error': currentStep.value && currentStep.value['validation'] && currentStep.value['validation'][name]
                                }"
                                :type="field.type ?? 'text'"
                        />

                        <span v-if="currentStep.value && currentStep.value['validation'] && currentStep.value['validation'][name]" class="error">
                          {{ currentStep.value['validation'][name] }}
                        </span>
                    </div>
                </template>

            </div>

            <div class="controls" v-if="currentStep.value && currentStep.value['buttons']">

                <button v-if="currentStep.value['buttons']['send_sms']" @click="confirmSMS" class="mainButton confirm"
                        :class="{ loading: isSendSMS }" :disabled="timer && timer.value">
                    {{ form.value.local['sms_confirm_send'] }}
                </button>

                <button v-if="currentStep.value['buttons']['send_email']" @click="confirmEmail"
                        class="mainButton confirm" :class="{ loading: isSendEmail }" :disabled="timer && timer.value">
                    {{ form.value.local['email_confirm_send'] }}
                </button>

                <button v-if="currentStep.value['buttons']['last_step']" @click="handleNextStep" class="mainButton end"
                        :class="{ loading: isNextStepLoading }">{{ form.value.local['end'] }}
                </button>
                <button v-if="currentStep.value['buttons']['next_step']" @click="handleNextStep" class="mainButton next"
                        :class="{ loading: isNextStepLoading, start: currentStepIndex === 0 }">{{ form.value.local['process'] }}
                </button>

                <button v-if="currentStep.value['buttons']['previous_step']"
                        @click="setStep(currentStepIndex.value - 1)"
                        class="controlButton prev">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                        <path d="M16.3334 10.5H4.66675" stroke="#4F4F4F" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round"/>
                        <path d="M10.5001 16.3334L4.66675 10.5001L10.5001 4.66675" stroke="#4F4F4F" stroke-width="2"
                              stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    {{ form.value.local['previous'] }}
                </button>

            </div>

        </form>
    </keep-alive>
</template>

<script setup>
import {ref, reactive, onMounted} from "vue";
import {vMaska} from "maska";
import axios from "axios";
import qs from "qs";
import VueSelect from 'vue-select'
import {reachTarget, ajax} from "@/assets/js/Functions"
import 'vue-select/dist/vue-select.css'
import '@/assets/css/form.css'
import * as functions from "@/assets/js/Functions";

const ajaxURL = (process.env.NODE_ENV === 'development' ? 'http://dev.dengoo.kz/wp-admin/admin-ajax.php' : '/wp-admin/admin-ajax.php')

const form = reactive({});
const formData = reactive({});

const currentStep = reactive({});
const currentStepIndex = ref(0);

let timer = reactive({});
let timerText = reactive({});
let userPhone = reactive({
    'phone': false,
    'confirm': false,
    'code': false
});
let userEmail = reactive({});
let userEmailCheck = reactive({});

let smsConfirmButtonText = reactive({});
let formProgress = reactive({});

const isValidationInProgress = ref(false);
const isNextStepLoading = ref(false);
const isSendSMS = ref(false);
const isSendEmail = ref(false);

onMounted(async () => {
    ajax({
        action: "get_registration_form_steps"
    }, (data) => {
        form.value = data;
        currentStep.value = data.steps[currentStepIndex.value];
        getProgress()
    })
});



// Маска поля
const formatMask = (field) => {
    if (!field.mask || field.mask === 'undefined') return null;
    let mask = field.mask.replace(/9/g, '#')
    field.placeholder = mask.replace(/[*#]/g, '_');
    return mask;
};

// Исключение первой цифры при вводе маски
const maskToken = (field) => {
    if (!field.mask || field.mask === 'undefined') return null;
    let exclude_number = field.exclude_digit || null;
    if (!exclude_number) return null;
    exclude_number = parseInt(exclude_number);
    exclude_number = (exclude_number === 9) ? '[0-8]' : '[0-' + (exclude_number - 1) + '-' + (exclude_number + 1) + '-9]';
    return "*:" + exclude_number;
}

const prepareSelectOptions = (json) => {
    if (typeof json === 'string') {
        return json.split('\r\n').map(item => {
            if (item.includes(' : ')) {
                const [value, label] = item.split(' : ');
                return { label: label.trim(), value: value.trim() };
            } else {
                return { label: item.trim(), value: item.trim() };
            }
        });
    } else {
        return Object.entries(json).map(([value, label]) => {
            return { label, value };
        });
    }
}


const confirmEmail = async () => {
    reachFormTargets('target_goal_doi_confirm')
    startTimer()
    isSendEmail.value = true
    ajax({
        action: "send_email_doi"
    }, (data) => {
        userEmail = data;
        isSendEmail.value = false
    })
}
const confirmSMS = async () => {
    reachFormTargets('target_goal_confirm_sms')
    startTimer()

    isSendSMS.value = true
    ajax({
        action: "send_sms_code"
    }, (data) => {
        if (data['code']){
            userPhone.code = data['code']
        }else if (data['status'] && data['status'] === 'error' && data['log']) {
            if(!currentStep.value.validation) currentStep.value.validation = {};
            currentStep.value.validation['sms-confirm'] = data['log']
        }

        isSendSMS.value = false
    })
}


const startTimer = () => {
    if (timer.value) clearInterval(timer.value);
    let remainingTime = timer.value ? timer.value : 35; // Используйте сохраненное время или 2 минуты
    const updateTimerText = () => {
        const minutes = Math.floor(remainingTime / 60);
        const seconds = remainingTime % 60;
        timerText.value = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`; // Обновляем timerText
    };


    smsConfirmButtonText.value = form.value.local['sms_confirm_send'];
    form.value.local['sms_confirm_send'] = form.value.local['sms_confirm_repeat_button']

    timer.value = setInterval(() => {
        if (remainingTime <= 0) {
            clearInterval(timer.value);
            timer.value = false;
            timerText.value = false;
            form.value.local['sms_confirm_send'] = smsConfirmButtonText.value; // Устанавливаем текст кнопки из переменной
            localStorage.removeItem('smsConfirmTimer'); // Удаляем сохраненное время из localStorage
            return;
        }

        updateTimerText(); // Обновляем timerText при каждом тике
        // Сохраняем оставшееся время в localStorage
        localStorage.setItem('smsConfirmTimer', remainingTime.toString());
        remainingTime -= 1;
    }, 1000);
}

const stepText = (description) => {
    if(description.includes('{{time}}')){
        const currentTime = new Date();
        currentTime.setMinutes(currentTime.getMinutes() + 9);
        const formattedTime = currentTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        description = description.replace(/\{\{time\}\}/g, formattedTime);
    }
    return description
}

const checkEmailUser = async () => {
    reachFormTargets('target_goal_doi_doble')
    isNextStepLoading.value = true
    ajax({
        action: "check_email_user",
        field: name
    }, (data) => {
        isNextStepLoading.value = false
        if (data && data.result && data.result.email) {
            return data.result.email.availability === 'available' && data.result.email.status === 'active';
        }
        return false
    })
}
const saveField = async (name, value) => {
    let saved = false

    ajax({
        action: 'save_field',
        field: name,
        value: value
    }, (data) => {
        saved = true
    })
    return saved;
}

const handleNextStep = async () => {
    if (isValidationInProgress.value) return
    if(currentStep.value.step_type === 'email-confirm'){
        reachFormTargets('target_goal_doi_noconfirm')
    }
    await validateStep();
};

const validateStep = async () => {

    if (currentStep.value && !currentStep.value.fields) {
        await setStep(currentStepIndex.value + 1)
        return;
    }

    isValidationInProgress.value = true;

    try {
        const entries = Object.entries(currentStep.value.fields);
        currentStep.value.validation = {};
        entries.forEach(([key, field]) => {
            let errorText = field.validate_empty ?? field.validate_error;
            if (
                field.required !== false &&
                ((field.mask && !field.completed) || ((field.value === '' && field.value !== '0') && !field.unmasked))
            )
                currentStep.value.validation[key] = errorText ?? form.value.local.required

            if (key === 'sms-confirm' && userPhone.confirm === false && field.required !== false) {
                currentStep.value.validation[key] = field.validate_error
            }

        })

        // Если пустые или не законченные поля - сразу выдаем ошибку валидации
        if (Object.keys(currentStep.value.validation).length > 0) return null;

        isNextStepLoading.value = true

        let formFields = {};
        entries.forEach(([key, field]) => {
            formFields[key] = (field.masked && field.mask ? field.masked.replace(/[ \-_\(\)]/g, '') : (field.value ?? ''))
        });

        formFields.fingerprint = localStorage.getItem('fingerprint');

        if (formFields.phone) {
            userPhone.confirm = (userPhone.phone === formFields.phone)
            userPhone.phone = formFields.phone
        }

        if (userPhone.confirm && userPhone.code){
            await saveField('phone_checked', 1)
            await reachFormTargets('target_goal_confirm_sms_done')
        }

        const response = await axios.post(
            ajaxURL,
            qs.stringify({
                action: 'form_save_step',
                step: formFields,
                lastStep: false
            }),
            {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            }
        );

        currentStep.value.validation = {...response.data.errors, ...currentStep.value.validation};

        if (Object.keys(currentStep.value.validation).length === 0) {
            formData.value = {...formData.value, ...formFields};
            await setStep(currentStepIndex.value + 1)
        }

        isNextStepLoading.value = false

    } catch (error) {
        console.error(error);
    } finally {
        // После завершения валидации сбросить состояние валидации
        isValidationInProgress.value = false;
    }
};

const handleInput = async (name, value = false) => {

    if (currentStep.value && currentStep.value.validation && currentStep.value.validation[name]) {
        delete currentStep.value.validation[name];
    }

    if (name === 'sms-confirm' && value && value.length === 4) {
        userPhone.confirm = (String(userPhone.code) === String(value))
        await validateStep()
    }

    return value
}


const setStep = async (newStep) => {
    if (newStep < 0) return;

    reachFormTargets('target_goal_next_button')
    // Определяем направление движения: назад или вперед
    const direction = newStep >= currentStepIndex.value ? 1 : -1;
    await setStepsVisible();

    // Получаем DOM-элемент формы
    const formElement = document.querySelector('form');
    // Скроллинг страницы к форме
    if (formElement) formElement.scrollIntoView({behavior: 'smooth'});

    // Поиск следующего видимого шага
    let nextVisibleStep = currentStepIndex.value + direction;
    const stepsCount = form.value['steps'].length;

    while (nextVisibleStep >= 0 && nextVisibleStep < stepsCount) {
        const nextStep = form.value.steps[nextVisibleStep];
        if (nextStep.visible !== false) {
            currentStepIndex.value = nextVisibleStep;
            currentStep.value = form.value.steps[currentStepIndex.value]
            await getProgress()
            return;
        }
        nextVisibleStep += direction;
    }

    await getProgress()
    if (nextVisibleStep >= stepsCount - 1) {
        await endForm();
    }
};


// Отправка целей
function reachFormTargets(targetName) {
    if (!form.value) return;
    let target_array = form.value.targets[targetName]

    for (let key in target_array) {
        if (target_array[key] !== '') {
            reachTarget(target_array[key], key);
        }
    }
}


// Количество всех видимых шагов
const getProgress = () => {
    //const visibleSteps = form.value.steps.filter((step) => step.visible);
    const visibleSteps = form.value.steps;
    const stepsCount = visibleSteps.length;
    const currentStep = currentStepIndex.value + 1;

    formProgress.currentStep = currentStep;
    formProgress.stepsCount = stepsCount;
    formProgress.percent = Math.min(Math.floor((currentStep / stepsCount) * 100), 99);

};


// Функция для проверки условий отображения шага
const setStepsVisible = async () => {

    for (const step of form.value['steps']) {

        if (step['step_type'] === 'sms-confirm') {
            step.visible = !userPhone.confirm;
            continue;
        }
        if (step['step_type'] === 'email-confirm') {
            if (!userEmailCheck.value && userEmailCheck.value !== false) userEmailCheck.value = await checkEmailUser();
            step.visible = !userEmailCheck.value;
            continue;
        }

        if (!step.conditions || step.conditions.length === 0) continue;
        // Переменная, которая будет хранить результат данного шага
        let stepVisible = false;

        for (const condition of step.conditions) {
            let conditionResult = true; // Сбрасываем результат перед проверкой нового условия
            for (const rule of condition) {
                const ruleType = rule['acf_fc_layout'];
                const field = rule.field;
                let value = rule.value;
                const operator = rule.comparison_operator;

                switch (ruleType) {
                    case 'entry_field_int':
                        value = parseInt(value)
                        // Проверяем условие на основе оператора
                        switch (operator) {
                            case "less":
                                conditionResult = conditionResult && formData.value[field] <= value;
                                break;
                            case "more":
                                conditionResult = conditionResult && formData.value[field] >= value;
                                break;
                            case "equals":
                                conditionResult = conditionResult && formData.value[field] === value;
                                break;
                            default:
                                // Если оператор не известен, считаем условие ложным
                                conditionResult = false;
                                break;
                        }
                        break;
                    case 'checkbox':

                        conditionResult = formData.value[field] == value
                        break;
                }

                // Если текущее условие не выполнилось, нет смысла проверять другие условия
                if (!conditionResult) {
                    break;
                }
            }
            // Если хотя бы одно из условий выполнилось, шаг видимый
            if (conditionResult) {
                stepVisible = true;
                break; // Нет смысла проверять другие условия, если уже известно, что шаг видимый
            }
        }
        step.visible = stepVisible; // Устанавливаем значение visible для шага
    }

}

const endForm = async () => {
    isNextStepLoading.value = true;
    await reachFormTargets('target_goal_form_full_fill');
    let response;

    try {
        response = await axios.post(
            ajaxURL,
            qs.stringify({
                action: "end_form",
            }),
            {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            }
        );
    } catch (error) {
        console.error(error);
        isNextStepLoading.value = false;
        return;
    }

    isNextStepLoading.value = false;
    window.location.href = response.data.url;
}

</script>